import React from "react";

export default function MentionsLegales() {
  return (
    <main style={{ maxWidth: 900, margin: "0 auto", padding: 16 }}>
      <h1>Mentions légales</h1>

      <p>
        Conformément aux dispositions des articles 6-III et 19 de la loi pour la
        Confiance dans l’Économie Numérique (LCEN), il est porté à la
        connaissance des utilisateurs du site <b>pdf-convert.fr</b> les présentes
        mentions légales.
      </p>

      <h2>Éditeur du site</h2>
      <ul>
        <li>
          <b>Nom</b> : Alexis Thery
        </li>
        <li>
          <b>Statut</b> : Particulier
        </li>
        <li>
          <b>Pays</b> : France
        </li>
        <li>
          <b>Email</b> : <a href="mailto:contact@pdf-convert.fr">contact@pdf-convert.fr</a>
        </li>
      </ul>

      <h2>Hébergement</h2>
      <p>
        Le site <b>pdf-convert.fr</b> est hébergé par :
      </p>
      <ul>
        <li>OVH SAS</li>
        <li>2 rue Kellermann</li>
        <li>59100 Roubaix – France</li>
      </ul>

      <h2>Responsabilité</h2>
      <p>
        Les outils proposés sont fournis « en l’état ». L’utilisateur est seul
        responsable de l’usage qu’il en fait. L’éditeur ne saurait être tenu
        responsable de dommages directs ou indirects liés à l’utilisation du site.
      </p>

      <h2>Propriété intellectuelle</h2>
      <p>
        L’ensemble des éléments présents sur le site (textes, structure, design,
        logo) est protégé par le droit de la propriété intellectuelle. Toute
        reproduction ou utilisation sans autorisation préalable est interdite.
      </p>
    </main>
  );
}
